import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { SalesforceMarketingCloudCopySource } from 'app/model/pipeline/copysource/salesforce-marketing-cloud.copysource';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SalesforceMarketingCloudCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*'
    }
})
export class SalesforceMarketingCloudCopySourceAdapter extends CopySourceAdapter<
    SalesforceMarketingCloudCopySource,
    Model.SalesforceMarketingCloudSource
> {
    protected override async _toResource(
        copySource: SalesforceMarketingCloudCopySource
    ): Promise<Model.SalesforceMarketingCloudSource> {
        return this._toTabularResource(copySource, Metamodel.modelFor(SalesforceMarketingCloudCopySource).name);
    }

    protected override async _toModel(
        resource: Model.SalesforceMarketingCloudSource,
        copyActivity: CopyActivity
    ): Promise<SalesforceMarketingCloudCopySource> {
        return this._toTabularModel(resource, copyActivity, SalesforceMarketingCloudCopySource.MODEL);
    }
}
